export function normalizeScale (val, baseMin, baseMax, scaleMin, scaleMax) {
  // short circuit if input range is flat
  if (baseMin === baseMax) return scaleMin
  if (val >= baseMax) return scaleMax
  if (val <= baseMin) return scaleMin

  return (val - baseMin) / (baseMax - baseMin) * (scaleMax - scaleMin) + scaleMin
}
